<template>
    <div>
        <p class="purple-title-bold">CONTURI BANCARE</p>
        <validation-observer #default="{ invalid }" ref="dateFinanciare">
            <span class="display-none">{{ invalid }}</span>
            <div v-for="(bank, key) in bank_accounts" :key="key" class="bank-accounts">
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="first-input"
                >
                    <b-form-group
                        id="fieldset-horizontal"
                        label-cols-lg="3"
                        content-cols-lg="9"
                        label="IBAN"
                        class="has-icon custom-responsive"
                    >
                        <b-form-input
                            v-model="bank.iban"
                            type="text"
                            :state="errors.length > 0 ? false : null"
                            :readonly="completed"
                        ></b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="first-input"
                >
                    <b-form-group
                        id="fieldset-horizontal"
                        label-cols-lg="3"
                        content-cols-lg="9"
                        label="Cont"
                        class="has-icon custom-responsive"
                    >
                        <b-form-input
                            v-model="bank.account"
                            type="text"
                            :state="errors.length > 0 ? false : null"
                            :readonly="completed"
                        ></b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <div class="flex flex-end mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        class="first-input v-50"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Banca"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="bank.bank"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        class="second-input v-50"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Sucursala"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="bank.bank_address"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <b-form-group
                        id="fieldset-horizontal"
                        label-cols-lg="3"
                        content-cols-lg="9"
                        label="Adresa sucursală"
                        class="has-icon custom-responsive"
                    >
                        <b-form-input
                            v-model="bank.bank_location"
                            type="text"
                            :state="errors.length > 0 ? false : null"
                            :readonly="completed"
                        ></b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <div class="flex flex-end mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        class="first-input w-48"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Swift"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="bank.swift"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        class="second-input v-50"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Alte informații"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="bank.other_info"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
                <b-icon-x-circle-fill v-if="key > 0" class="delete-icon" @click="deleteBankAccount(key)"></b-icon-x-circle-fill>
            </div>
            <a class="add-button mb-3" style="float: right" @click="addBankAccount()">
                <p>Adaugă un cont bancar</p>
                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
            </a>


            <p class="purple-title-bold mt-5">EXERCIȚII FINANCIARE</p>
            <div v-for="(exercitiu, key) in financial_exercises" :key="key + 'e'" class="exercitiu-financiar">
                <div class="position-relative">
                    <p class="an">{{ exercitiu.year }}</p>
                    <b-icon-x-circle-fill v-if="key > 2" class="delete-icon-exercise" @click="deleteFinancialExercise(key)"></b-icon-x-circle-fill>
                </div>

                <div class="exercitiu-body">
                    <div class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Dată de început perioadă"
                                class="has-icon custom-responsive"
                            >
                                <b-form-datepicker
                                    v-model="exercitiu.date_start"
                                    class="w-100"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :max="max"
                                    placeholder="Selectează o dată"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Dată sfârșit perioadă"
                                class="has-icon custom-responsive"
                            >
                                <b-form-datepicker
                                    v-model="exercitiu.date_end"
                                    class="w-100"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    locale="ro"
                                    placeholder="Selectează o dată"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>
                    <div class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Număr mediu angajați"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.employees"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.employees ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Cifra de afaceri/Venituri totale"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.turnover"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.turnover ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>
                    <div class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Active totale"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.active"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.active ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Profit net"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.profit_net"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.profit_net ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>
                    <div class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Venituri cercetare"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.incomes"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.incomes ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Profit în exploatare"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="exercitiu.profit"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] ? errors[0] : (exercitiu.profit ? '' : 'Completează acest câmp!') }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>
                </div>
            </div>
            <a class="add-button mb-3" style="float: right" @click="addExercise()">
                <p>Adaugă exercițiu</p>
                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
            </a>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                @change="sendForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BIconPlusCircleFill, BIconXCircleFill, BFormDatepicker, BFormCheckbox } from "bootstrap-vue";
    import _ from "lodash";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    require('@/helpers/validations/validations');
    export default{
        name: 'CFDateFinanciare',
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BIconPlusCircleFill,
            BIconXCircleFill,
            BFormDatepicker,
            BFormCheckbox,
            ValidationProvider, ValidationObserver
        },
        props: {
            data: null,
            termeneV1: null,
            termeneV3: null,
            m3GrantApplication: null,
        },
        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth())
            maxDate.setDate(maxDate.getDay() + 4)

            return {
                completed: false,
                bank_accounts: [
                    {
                        iban: '',
                        account: '',
                        bank: '',
                        bank_location: '',
                        bank_address: '',
                        swift: '',
                        other_info: ''
                    }
                ],
                financial_exercises: [
                    {
                        year: 2020,
                        date_start: '2020-01-01',
                        date_end: '2020-12-31',
                        employees: '',
                        turnover: '',
                        active: '',
                        profit_net: '',
                        incomes: '0',
                        profit: ''
                    },
                    {
                        year: 2019,
                        date_start: '2019-01-01',
                        date_end: '2019-12-31',
                        employees: '',
                        turnover: '',
                        active: '',
                        profit_net: '',
                        incomes: '0',
                        profit: ''
                    },
                    {
                        year: 2018,
                        date_start: '2018-01-01',
                        date_end: '2018-12-31',
                        employees: '',
                        turnover: '',
                        active: '',
                        profit_net: '',
                        incomes: '0',
                        profit: ''
                    },
                ],
                max: maxDate
            }
        },
        watch:{
            termeneV3: {
                handler: function() {
                    if(this.m3GrantApplication) {
                        if(this.m3GrantApplication.solicitant && this.m3GrantApplication.solicitant.financial_exercises && this.m3GrantApplication.solicitant.financial_exercises.length > 0) {
                            this.bank_accounts = this.m3GrantApplication.solicitant.bank_accounts
                            this.financial_exercises = this.m3GrantApplication.solicitant.financial_exercises
                            this.completed = true
                        } else {
                            this.setExerciseData(2020)
                            this.setExerciseData(2019)
                            if(this.termeneV3.vechime > 3) {
                                this.setExerciseData(2018)
                            } else {
                                this.financial_exercises.splice(2,1)
                            }

                        }
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication) {
                if(this.m3GrantApplication.solicitant && this.m3GrantApplication.solicitant.financial_exercises && this.m3GrantApplication.solicitant.financial_exercises.length > 0) {
                    this.bank_accounts = this.m3GrantApplication.solicitant.bank_accounts
                    this.financial_exercises = this.m3GrantApplication.solicitant.financial_exercises
                    this.completed = true
                } else {
                    this.setExerciseData(2020)
                    this.setExerciseData(2019)
                    if(this.termeneV3.vechime > 3) {
                        this.setExerciseData(2018)
                    } else {
                        this.financial_exercises.splice(2,1)
                    }
                }
            }

        },
        methods: {
            addBankAccount() {
                if(!this.completed){
                    this.bank_accounts.push(
                        {
                            iban: '',
                            account: '',
                            bank: '',
                            bank_location: '',
                            bank_address: '',
                            swift: '',
                            other_info: ''
                        }
                    )
                } else{
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            },
            deleteBankAccount(key){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.bank_accounts.splice(key,1)
                }
            },
            deleteFinancialExercise(key) {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.financial_exercises.splice(key, 1)
                }
            },
            setExerciseData(year) {
                let bilant = _.filter(this.termeneV3.bilant_scurt, v => v.an === year);
                let exercitiu = _.filter(this.financial_exercises, v => v.year === year);
                if(bilant[0] && exercitiu[0]) {
                    exercitiu[0].year = year ? year : ''
                    exercitiu[0].date_start = year ? year+'-01-01' : ''
                    exercitiu[0].date_end = year ? year+'-12-31' : ''
                    exercitiu[0].employees = bilant[0].numar_mediu_angajati ? bilant[0].numar_mediu_angajati : ''
                    exercitiu[0].turnover = bilant[0].cifra_de_afaceri_neta ? bilant[0].cifra_de_afaceri_neta : ''
                    exercitiu[0].active = bilant[0].active_circulante && bilant[0].active_imobilizate ? bilant[0].active_circulante + bilant[0].active_imobilizate : ''
                    exercitiu[0].profit_net = bilant[0].profit_net ? bilant[0].profit_net : ''
                }
                this.$refs.dateFinanciare.reset()
            },
            addExercise(){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    if(this.financial_exercises && this.financial_exercises.length) {
                        let lastExerciseYear = this.financial_exercises[this.financial_exercises.length -1].year
                        this.financial_exercises.push({
                            year: lastExerciseYear-1,
                            date_start: lastExerciseYear-1+'-01-01',
                            date_end: lastExerciseYear-1+'-12-31',
                            employees: '',
                            turnover: '',
                            active: '',
                            profit_net: '',
                            incomes: '0',
                            profit: ''
                        })
                    } else {
                        this.financial_exercises.push({
                            year: '2020',
                            date_start: '2020-01-01',
                            date_end: '2020-12-31',
                            employees: '',
                            turnover: '',
                            active: '',
                            profit_net: '',
                            incomes: '0',
                            profit: ''
                        })
                    }
                }
            },
            sendForm() {
                this.$refs.dateFinanciare.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.completed = true
                            this.$emit('dateFinanciare', {'bank_accounts': this.bank_accounts, 'financial_exercises': this.financial_exercises})
                        } else {
                            this.completed = false
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 41.4%;
}
.bank-accounts .first-input{
    width: 44.9% !important;
}
.second-input{
    width: 41.4%;
}
.bank-accounts, .exercitiu-financiar{
    position: relative;
    padding-bottom: 15px;
    padding-top: 15px;
}
.delete-icon{
    position: absolute;
    top: 45%;
    margin: auto 0;
    left: 85px;
    color: var(--dangerColor);
    cursor: pointer;
}
.delete-icon-exercise{
    color: var(--dangerColor);
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 110px;
}
.exercitiu-financiar .an{
    font-size: 16px;
    color: #8b6a85;
    font-weight: 700;
    padding: 6px 15px;
    border-radius: 6px;
    border: 2px solid #e9ecef;
    max-width: 100px;
    text-align: center;
}
.exercitiu-financiar .exercitiu-body{
    padding: 15px;
    border-radius: 6px;
    border: 2px solid #e9ecef;
    margin-top: 10px;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
@media screen and (max-width: 1441px){
    .bank-accounts .first-input{
        width: 48% !important;
    }
}
</style>
